import { MetaInfo } from 'vue-meta';

const META_INFO_TEMPLATE: MetaInfo = {
  bodyAttrs: {
    class: 'service',
  },
  meta: [
    { property: 'viewport', content: 'width=device-width' },
    { name: 'robots', content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1' },
    { property: 'og:locale', content: 'ja_JP' },
    { property: 'og:type', content: 'article' },
    { property: 'og:site_name', content: 'RemoLabo' },
    { property: 'article:publisher', content: 'https://www.facebook.com/RemoLabo/' },
    { property: 'article:modified_time', content: '2023-04-14T13:02:46+00:00' },
    { property: 'og:image', content: 'https://remolabo.net/service/newlp/wp-content/uploads/2021/06/RemoLabo1_1200x628.jpg' },
    { property: 'og:image:width', content: '1200' },
    { property: 'og:image:height', content: '628' },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:site', content: '@RemoLabo_IDH' },
  ],
};

export function metaInfo(target: MetaInfo): MetaInfo {
  target.bodyAttrs = META_INFO_TEMPLATE.bodyAttrs;
  target.meta = target.meta ? target.meta.concat(META_INFO_TEMPLATE.meta!) : META_INFO_TEMPLATE.meta;
  return target;
}

export default class {
  public mountedProcess() {
    // gtm
    if (process.env.VUE_APP_MODE === 'PROD') {
      const GTA = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-PZGPC3J');`;
      const GTABody = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PZGPC3J" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
      const gtaScript: any = document.createElement('script');
      gtaScript.type = '';
      gtaScript.innerText = GTA;
      gtaScript.id = 'lp_gta';
      document.head.appendChild(gtaScript);
      const gtaBodyScript: any = document.createElement('noscript');
      gtaBodyScript.type = '';
      gtaBodyScript.innerText = GTABody;
      gtaBodyScript.id = 'lp_gta2';
      document.body.appendChild(gtaBodyScript);
    }
  }

  public destroyProcess() {
    // gtm
    if (document.getElementById('lp_gta')) {
      (document.getElementById('lp_gta') as HTMLInputElement).remove();
    }
    if (document.getElementById('lp_gta2')) {
      (document.getElementById('lp_gta2') as HTMLInputElement).remove();
    }
  }
}
